import React, { memo } from 'react';
import { KContainer, KGrid } from 'uikit';

import Equiqments from './Equipments';
import NotificationTab from './Notifications';
import Summary from './Summary';
import WaitingTrip from './WaitingTrip';

// import { useDashboardItem } from '../helpers';

const Operation = () => {
  // const {
  //   showTransportJobs,
  //   showIssues,
  //   showScheduleTripContainerWaitingTime
  // } = useDashboardItem();

  return (
    <KContainer.View marginB={'1rem'}>
      <KContainer.View padding="0.75rem">
        <KGrid.Container spacing={2} alignItems="stretch">
          {/* Left Section */}
          <KGrid.Item xs={8}>
            <KGrid.Container spacing={2}>
              <KGrid.Item xs={12}>
                <Summary />
              </KGrid.Item>

              <KGrid.Item xs={12}>
                <Equiqments />
              </KGrid.Item>

              <KGrid.Item xs={12}>
                <WaitingTrip />
              </KGrid.Item>
            </KGrid.Container>
          </KGrid.Item>

          {/* Right Section */}
          <KGrid.Item xs={4}>
            <KGrid.Container spacing={2}>
              <KGrid.Item xs={12}>
                <NotificationTab />
              </KGrid.Item>
            </KGrid.Container>
          </KGrid.Item>
        </KGrid.Container>
      </KContainer.View>
    </KContainer.View>

    // <KContainer.View marginB={'1rem'}>
    //   <KContainer.View padding="0.75rem">
    //     <KGrid.Container>
    //       <KContainer.RenderWhen>
    //         <KContainer.RenderWhen.If
    //           isTrue={showTransportJobs || showContainers || showPayments}
    //         >
    //           <KGrid.Item xs={12}>
    //             <KGrid.Container>
    //               {showTransportJobs && (
    //                 <KGrid.Item xs={3}>
    //                   <TransportJobs />
    //                 </KGrid.Item>
    //               )}

    //               {showContainers && (
    //                 <KGrid.Item xs={6}>
    //                   <Containers />
    //                 </KGrid.Item>
    //               )}

    //               {showPayments && (
    //                 <KGrid.Item xs={3}>
    //                   <Payments />
    //                 </KGrid.Item>
    //               )}
    //             </KGrid.Container>
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>
    //       </KContainer.RenderWhen>

    //       <KGrid.Item xs={show1Stop ? 6 : 12}>
    //         <Notifications />
    //       </KGrid.Item>

    //       <KContainer.RenderWhen limit={6}>
    //         <KContainer.RenderWhen.If isTrue={show1Stop}>
    //           <KGrid.Item xs={6}>
    //             <Notifications1Stop />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>

    //         <KContainer.RenderWhen.If isTrue={showIssues}>
    //           <KGrid.Item xs={6}>
    //             <Issues />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>

    //         <KContainer.RenderWhen.If isTrue={showAllocation}>
    //           <KGrid.Item xs={6}>
    //             <Allocation />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>

    //         <KContainer.RenderWhen.If isTrue={showInvoiceOverdue}>
    //           <KGrid.Item xs={6}>
    //             <InvoicesOverdue />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>

    //         <KContainer.RenderWhen.If isTrue={showAROverdue}>
    //           <KGrid.Item xs={6}>
    //             <ArOverdue />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>

    //         <KContainer.RenderWhen.If
    //           isTrue={showScheduleTripContainerWaitingTime}
    //         >
    //           <KGrid.Item xs={12}>
    //             <STCWaitingTime />
    //           </KGrid.Item>
    //         </KContainer.RenderWhen.If>
    //       </KContainer.RenderWhen>
    //     </KGrid.Container>
    //   </KContainer.View>
    // </KContainer.View>
  );
};

export default memo(Operation);
